/**
 * Dirección pública de la guía para los enlaces copiados (p. ej. 'https://guia.muvanguard.com').
 * Vacío = se usa la dirección desde la que se abrió la página.
 * Rellénalo con tu dominio para que "Copiar enlace" nunca comparta la dirección de vista previa.
 */
export const PUBLIC_SITE_URL = ''
